import { Box, Button, Flex, Table, TableContainer, Tbody, Td, Tr } from '@chakra-ui/react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import TableActions from '../../common/TableActions/TableActions';
import TableHeader from '../../common/TableHeader/TableHeader';
import useItemLister from '../../core/hooks/useItemLister';
import { Industry } from '../../core/models/Industry';

const FILTERS = ['name'];

const COLS: {
  label: string;
  sort?: string;
  isNumeric?: boolean;
}[] = [
  {
    label: 'Name',
    sort: 'name',
  },
  {
    label: 'Published',
    sort: 'published',
  },
  {
    label: 'Actions',
    isNumeric: true,
  },
];

function IndustriesLister() {
  const navigate = useNavigate();
  const { items, activeId, deleteItem, deleteLoading, Lister, sort, changeSort, setIsActive } =
    useItemLister({
      endpointSingle: 'industry',
      endpointPlural: 'industries',
      filters: FILTERS,
    });

  useEffect(() => {
    setIsActive(true);

    return () => {
      setIsActive(false);
    };
  }, []);

  return (
    <>
      <Flex>
        <h1 className="h3">Industries</h1>
        <Button
          colorScheme="messenger"
          type="button"
          shadow="lg"
          ml="auto"
          onClick={() => navigate(`/industry/new`)}
        >
          Create New
        </Button>
      </Flex>
      {Lister({
        children: (
          <Box my={5}>
            <TableContainer fontSize="1rem" boxShadow="xl">
              <Table variant="striped" colorScheme="facebook">
                <TableHeader cols={COLS} sort={sort} changeSort={changeSort} />
                <Tbody>
                  {items?.map((industry: Industry) => (
                    <Tr key={industry._id}>
                      <Td p={2} verticalAlign="middle">
                        <button
                          style={{ padding: '6px' }}
                          type="button"
                          onClick={() => navigate(`/industry/${industry._id}`)}
                        >
                          {industry.name}
                        </button>
                      </Td>
                      <Td
                        p={2}
                        verticalAlign="middle"
                        style={{ color: industry.published ? 'green' : '' }}
                      >
                        {industry.published ? 'Published' : 'Unpublished'}
                      </Td>
                      <Td p={2} verticalAlign="middle">
                        <TableActions
                          item={industry}
                          path="industry"
                          activeId={activeId}
                          deleteItem={deleteItem}
                          deleteLoading={deleteLoading}
                        />
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </TableContainer>
          </Box>
        ),
      })}
    </>
  );
}

export default IndustriesLister;
